var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapboxPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 15.142,
    viewBox: "0 0 10 15.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Color",
    "data-name": " \\u21B3Color",
    d: "M5,15.142H5a34.2,34.2,0,0,1-2.5-3.43C1.36,9.92,0,7.353,0,5.3A5.431,5.431,0,0,1,1.463,1.551a4.807,4.807,0,0,1,7.073,0A5.431,5.431,0,0,1,10,5.3c0,2.053-1.36,4.62-2.5,6.412A34.2,34.2,0,0,1,5,15.142ZM5,3.407A1.844,1.844,0,0,0,3.214,5.3,1.844,1.844,0,0,0,5,7.193,1.844,1.844,0,0,0,6.786,5.3,1.844,1.844,0,0,0,5,3.407Z",
    fill: "#0f3557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapboxPin);
export default __webpack_public_path__ + "static/media/mapbox_pin.a979a81d89cf72710f956ba8e3c13532.svg";
export { ForwardRef as ReactComponent };